import * as React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip, Button } from 'antd';
import { VIEWER_MODULE_WHATS_CHANGING_HELP } from '@src/utils/help/links';
import { StyledWarningTags } from './styled';

export interface InvalidDimensionWarningProps {
  title?: React.ReactNode;
  style?: React.CSSProperties;
}

export const INVALID_DIMENSION_WARNING_CONTENT = 'The dimension has been deleted, please remove it';
export const CUSTOM_TAG_WARNING_CONTENT = (
  <StyledWarningTags>
    <span>
      Support for filters containing custom tags stops from 6th Feb 2025. However, you can convert
      the required Tags to Dimensions by using Dimension Management under Settings or contact
      support for assistance.
    </span>
    <Button type="link" href={VIEWER_MODULE_WHATS_CHANGING_HELP} target="_blank">
      Learn more
    </Button>
  </StyledWarningTags>
);

const InvalidDimensionWarning = (props: InvalidDimensionWarningProps) => {
  const { title = INVALID_DIMENSION_WARNING_CONTENT, style } = props;

  return (
    <Tooltip title={title}>
      <InfoCircleOutlined
        style={{
          color: '#d0021b',
          alignSelf: 'center',
          pointerEvents: 'initial',
          cursor: 'pointer',
          ...style,
        }}
      />
    </Tooltip>
  );
};

export default React.memo(InvalidDimensionWarning);
